const CONST_SETTING_URL = {
  SEND_PASSWORD: 'パスワード再設定用URL送信',
  SEND: '送　　信',
  EMAIL_ADDRESS: 'メールアドレス',
  SEND_SUCCESS: 'パスワード再設定用URLが送信されました',
  PLACEHOLDER_EMAIL: '例  moai@example.com',
  MAIL_WAITING_SETTING_PASSWORD: '送信失敗しました。アカウントが初回ログイン待ち中です。',
};

export default CONST_SETTING_URL;
